"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _browserImageCompression = _interopRequireDefault(require("browser-image-compression"));

var _constant = require("../constant");

var _constant2 = require("./constant");

var _photoUpload = _interopRequireDefault(require("./photoUpload.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var PhotoUploadContainer = _styledComponents.default.div.withConfig({
  displayName: "PhotoUpload__PhotoUploadContainer",
  componentId: "sc-1jhoj8b-0"
})(["display:flex;flex-direction:column;"]);

var LabelContainer = _styledComponents.default.label.withConfig({
  displayName: "PhotoUpload__LabelContainer",
  componentId: "sc-1jhoj8b-1"
})(function (_ref) {
  var theme = _ref.theme;
  return "\n    margin-top: ".concat(theme.space.small, ";\n    margin-bottom: ").concat(theme.space.tiny, ";\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n    width: fit-content;\n    padding: ").concat(theme.space.micro, " ").concat(theme.space.small, ";\n    border: 1px solid ").concat(theme.colors.greyLight, ";\n    border-radius: ").concat(theme.borderRadius.XLarge, ";\n    ");
});

var HeadlineContainer = _styledComponents.default.div.withConfig({
  displayName: "PhotoUpload__HeadlineContainer",
  componentId: "sc-1jhoj8b-2"
})(["display:inline-flex;"]);

var DescriptionContainer = _styledComponents.default.div.withConfig({
  displayName: "PhotoUpload__DescriptionContainer",
  componentId: "sc-1jhoj8b-3"
})(["margin-top:", ";@media screen and (max-width:", "){margin-top:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.tiny;
}, _constant.BREAKPOINTS.MOBILE, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.micro;
});

var PhotoIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "PhotoUpload__PhotoIcon",
  componentId: "sc-1jhoj8b-4"
})(["margin-right:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.XSmall;
});

var Option = _styledComponents.default.span.withConfig({
  displayName: "PhotoUpload__Option",
  componentId: "sc-1jhoj8b-5"
})(["margin-left:", ";color:", ";font-size:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.micro;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyMedium;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.XSmall;
});

var PhotoDescription = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "PhotoUpload__PhotoDescription",
  componentId: "sc-1jhoj8b-6"
})([""]);
var Headline = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "PhotoUpload__Headline",
  componentId: "sc-1jhoj8b-7"
})(["margin-top:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.tiny;
});

var ImageContainer = _styledComponents.default.span.withConfig({
  displayName: "PhotoUpload__ImageContainer",
  componentId: "sc-1jhoj8b-8"
})(["margin-right:", ";width:", ";height:", ";display:inline-block;align-items:left;position:relative;"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.small;
}, _constant2.IMAGE_CONTAINER.WIDTH, _constant2.IMAGE_CONTAINER.WIDTH);

var Image = _styledComponents.default.img.withConfig({
  displayName: "PhotoUpload__Image",
  componentId: "sc-1jhoj8b-9"
})(["width:", ";height:", ";object-fit:cover;padding:", ";border-radius:", ";"], _constant2.IMAGE.WIDTH, _constant2.IMAGE.WIDTH, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.XSmall;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.small;
});

var Delete = _styledComponents.default.div.withConfig({
  displayName: "PhotoUpload__Delete",
  componentId: "sc-1jhoj8b-10"
})(["position:absolute;z-index:1;right:0;cursor:pointer;color:", ";border:1px solid ", ";border-radius:", ";background:", ";font-size:", ";display:inline-block;line-height:", ";padding:", ";font-family:", ";margin-right:-", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.default;
}, _constant2.DELETE.BORDER_COLOR, function (_ref13) {
  var theme = _ref13.theme;
  return theme.lineHeight.titleSmall;
}, _constant2.DELETE.BACKGROUND, function (_ref14) {
  var theme = _ref14.theme;
  return theme.lineHeight.XSmall;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.none;
}, function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.space.xtiny, " ").concat(theme.space.micro, " ").concat(theme.space.XXXSmall);
}, _constant2.DELETE.FONT, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.XSmall;
});

var Container = _styledComponents.default.div.withConfig({
  displayName: "PhotoUpload__Container",
  componentId: "sc-1jhoj8b-11"
})(["min-height:100%;max-height:auto;width:100%;background-color:", ";margin-top:", ";display:flex;flex-wrap:wrap;align-items:center;justify-content:left;"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.default;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.small;
});

var Preview = _styledComponents.default.div.withConfig({
  displayName: "PhotoUpload__Preview",
  componentId: "sc-1jhoj8b-12"
})(["margin-left:-", ";display:flex;flex-direction:row;"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.XSmall;
});

var PhotoUpload = function PhotoUpload(props) {
  var id = props.id,
      label = props.label,
      description = props.description,
      icon = props.icon,
      theme = props.theme,
      customProperties = props.customProperties,
      headline = props.headline,
      optional = props.optional,
      accessibility = props.accessibility,
      bottomDescription = props.bottomDescription,
      limit = props.limit,
      getPhoto = props.getPhoto,
      getCompPhoto = props.getCompPhoto,
      onChange = props.onChange,
      compPhotoType = props.compPhotoType;
  var tabIndex = !accessibility ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      photo = _useState2[0],
      setPhoto = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      compPhoto = _useState4[0],
      setCompPhoto = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      files = _useState6[0],
      setFiles = _useState6[1];

  function uploadPhoto(_x) {
    return _uploadPhoto.apply(this, arguments);
  }

  function _uploadPhoto() {
    _uploadPhoto = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var options, compressedFile;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPhoto([].concat((0, _toConsumableArray2.default)(photo), [URL.createObjectURL(e.target.files[0])]));
              setFiles([].concat((0, _toConsumableArray2.default)(files), [e.target.files[0]]));
              options = {
                maxIteration: 1000,
                fileType: compPhotoType
              };
              _context.prev = 3;
              _context.next = 6;
              return (0, _browserImageCompression.default)(e.target.files[0], options);

            case 6:
              compressedFile = _context.sent;
              setCompPhoto([].concat((0, _toConsumableArray2.default)(compPhoto), [compressedFile]));
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3); // eslint-disable-next-line no-console

              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));
    return _uploadPhoto.apply(this, arguments);
  }

  function deletePhoto(e) {
    var picture = photo.filter(function (item, index) {
      return index !== e;
    });
    var compPicture = compPhoto.filter(function (item, index) {
      return index !== e;
    });
    var deletedFiles = files.filter(function (item, index) {
      return index !== e;
    });
    setPhoto(picture);
    setCompPhoto(compPicture);
    setFiles(deletedFiles);
  }

  if (getPhoto) {
    getPhoto(photo);
  }

  if (getCompPhoto) {
    getCompPhoto(compPhoto);
  }

  if (onChange) {
    onChange(files);
  }

  var getLabel = function getLabel() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, description && /*#__PURE__*/_react.default.createElement(DescriptionContainer, null, /*#__PURE__*/_react.default.createElement(PhotoDescription, {
      display: "block",
      color: _constant2.PHOTO_UPLOAD_DEFAULTS.DESC_COLOR,
      type: "small"
    }, description)), /*#__PURE__*/_react.default.createElement(LabelContainer, {
      htmlFor: id,
      tabIndex: tabIndex,
      id: "photoupload-label"
    }, /*#__PURE__*/_react.default.createElement(PhotoIcon, {
      icon: icon,
      fontsize: "medium",
      color: _constant2.PHOTO_UPLOAD_DEFAULTS.ICON_COLOR,
      accessible: false
    }), /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "sub",
      textLimit: 30,
      theme: theme,
      accessible: false
    }, label)), /*#__PURE__*/_react.default.createElement("input", {
      id: id,
      type: "file",
      hidden: true,
      onChange: uploadPhoto,
      accept: "image/*"
    }), bottomDescription && /*#__PURE__*/_react.default.createElement(DescriptionContainer, null, /*#__PURE__*/_react.default.createElement(PhotoDescription, {
      display: "block",
      color: _constant2.PHOTO_UPLOAD_DEFAULTS.DESC_COLOR,
      type: "small"
    }, bottomDescription)));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PhotoUploadContainer, customProperties, headline && /*#__PURE__*/_react.default.createElement(HeadlineContainer, null, /*#__PURE__*/_react.default.createElement(Headline, {
      className: "photo_upload_headline",
      display: "block",
      type: "medium"
    }, headline, /*#__PURE__*/_react.default.createElement(Option, null, optional))), limit ? photo.length < limit && getLabel() : getLabel(), /*#__PURE__*/_react.default.createElement(Container, {
      id: "preview-container"
    }, /*#__PURE__*/_react.default.createElement(Preview, null, photo.length > 0 && photo.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(ImageContainer, {
        key: item
      }, /*#__PURE__*/_react.default.createElement(Delete, {
        onClick: function onClick() {
          return deletePhoto(index);
        }
      }, " x "), /*#__PURE__*/_react.default.createElement(Image, {
        src: item,
        alt: ""
      }));
    }))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PhotoUpload.propTypes = _photoUpload.default.PropTypes;
PhotoUpload.defaultProps = _photoUpload.default.DefaultProps;
var _default = PhotoUpload;
exports.default = _default;